import styled from "@xstyled/styled-components";

import { media } from "@otta/design";
import { Asset } from "@otta/search/components/AssetSprinkler/Asset";

export const DesktopAsset = styled(Asset)`
  ${media({ to: "desktop" })`
  display: none;
  `}
`;
